module.exports = __webpack_public_path__ + "static/media/full-screen-icon.a6788abf.svg";